<template>
  <div class="accordion" aria-label="Accordion Control Group Buttons">
    <header v-if="!expandLink" class="accordion__header accordion__header--full">
      <button
        :aria-controls="id"
        aria-expanded="false"
        :id="`accordion-control-${id}`"
        @click="toggleAccordion"
      >{{title}}</button>
    </header>
    <header v-else class="accordion__header">
      <div class="accordion__title">{{title}}</div>
      <div class="accordion__subtitle" v-if="subtitle">{{subtitle}}</div>
      <div class="accordion__button">
        <button
          :aria-controls="id"
          :aria-expanded="ariaExpanded"
          :id="`accordion-control-${id}`"
          @click="toggleAccordion"
          type="button"
        >{{expandLink}}</button>
      </div>
    </header>

    <div
      :aria-hidden="ariaHidden"
      :id="id"
      class="accordion__content"
      :class="{'accordion__content--open': open}"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",

  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    expandLink: String,
    isOpen: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      id: null,
      ariaExpanded: "false",
      ariaHidden: "true",
      open: this.isOpen
    };
  },

  methods: {
    toggleAccordion() {
      this.open = !this.open;
      this.ariaExpanded = this.ariaExpanded === "true" ? "false" : "true"; // needs to be a string
      this.ariaHidden = this.ariaHidden === "true" ? "false" : "true"; // needs to be a string
    }
  },

  mounted() {
    this.id = this._uid;
  }
};
</script>

<style scoped lang="scss">
.accordion {
  border: 1px solid $colour-nhs-pale-grey;
  background: $colour-nhs-core-white;
  margin-bottom: 20px;
  border-radius: 4px;

  &__header {
    padding: 10px;
    box-sizing: border-box;
    display: flex;

    align-items: center;

    button {
      background: transparent;
      cursor: pointer;
      border: none;
      padding-left: 0;
      font-size: 14px;
      outline: none;
      color: $colour-cactus-core-green;
    }

    &--full {
      button {
        width: 100%;
        text-align: left;
        font-size: 20px;
        line-height: 1.2;
      }
    }
  }

  &__title {
    font-size: 20px;
    line-height: 1.2;
    color: $colour-nhs-black;
    width: 33.333%;
    flex: 2;
  }

  &__subtitle {
    font-size: 16px;
    line-height: 1.2;
    color: $colour-nhs-dark-grey;
    max-width: 50%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 33.333%;
    flex: 3;
  }

  &__button {
    flex: 1;
    text-align: right;
  }
  &__content {
    display: none;
    padding: 10px;
    box-sizing: border-box;

    &--open {
      display: block;
    }
  }
}
</style>
